import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Calendar } from "lucide-react";
import { api } from "../utils/api";

export default function CABCalendar() {
  const [crs, setCrs] = useState([]);
  useEffect(() => {
    api.get("/api/change-requests").then((r) => {
      const filtered = (r.data || []).filter((c) => c.scheduled_implementation_at);
      filtered.sort((a, b) => new Date(a.scheduled_implementation_at) - new Date(b.scheduled_implementation_at));
      setCrs(filtered);
    });
  }, []);

  // Group by date (YYYY-MM-DD)
  const groups = {};
  crs.forEach((c) => {
    const day = (c.scheduled_implementation_at || "").slice(0, 10);
    if (!groups[day]) groups[day] = [];
    groups[day].push(c);
  });

  return (
    <div className="space-y-4">
      <div className="flex items-center gap-2">
        <Calendar className="text-brand-500" />
        <h1 className="text-2xl font-bold">CAB Calendar</h1>
      </div>
      <p className="text-sm text-gray-600">Scheduled Change Requests grouped by date. Set a schedule on any CR detail page.</p>

      {crs.length === 0 && <div className="card p-6 text-center text-gray-500">No CRs are scheduled yet.</div>}

      {Object.keys(groups).sort().map((day) => (
        <div key={day} className="card p-5">
          <h2 className="font-semibold mb-3">
            {new Date(day + "T00:00:00").toLocaleDateString(undefined, { weekday: "long", year: "numeric", month: "short", day: "numeric" })}
            <span className="ml-2 text-sm text-gray-500">({groups[day].length})</span>
          </h2>
          <table className="w-full text-sm">
            <thead className="text-left text-gray-600">
              <tr><th className="p-2">Time</th><th className="p-2">CR</th><th className="p-2">Title</th><th className="p-2">Type</th><th className="p-2">Plant</th><th className="p-2">Status</th><th className="p-2">Owner</th></tr>
            </thead>
            <tbody>
              {groups[day].map((c) => (
                <tr key={c.id} className="border-t">
                  <td className="p-2 font-mono text-xs">{new Date(c.scheduled_implementation_at).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}</td>
                  <td className="p-2 font-mono text-xs">
                    <Link to={`/change-requests/${c.id}`} className="text-brand-600 hover:underline">{c.change_number}</Link>
                  </td>
                  <td className="p-2">{c.title}</td>
                  <td className="p-2"><span className="badge bg-gray-100 text-gray-700">{c.change_type}</span></td>
                  <td className="p-2">{c.plant}</td>
                  <td className="p-2"><span className="badge bg-brand-50 text-brand-700">{c.status}</span></td>
                  <td className="p-2">{c.assigned_to_name || c.requester_name}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ))}
    </div>
  );
}
